import { render } from "./MiniCart.vue?vue&type=template&id=3c7e4ef2"
import script from "./MiniCart.vue?vue&type=script&lang=js"
export * from "./MiniCart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__